export default __webpack_public_path__ + "static/media/img-0235-australia-full-face.d3595fd6.png";